import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const ReviewStars = ({ title, rating }) => {
  // Calculate the number of full, half, and empty stars
  const normalizedRating = rating || 0;
  const fullStars = Math.floor(normalizedRating / 2); // Full stars (out of 5)
  const hasHalfStar = (normalizedRating / 2) % 1 >= 0.5; // Check for half star (0.5+)
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  
  const { t } = useTranslation("global");

  // Create an array of star elements
  const stars = [];
  for (let i = 0; i < fullStars; i++) stars.push("full");
  if (hasHalfStar) stars.push("half");
  for (let i = 0; i < emptyStars; i++) stars.push("empty");
  
  if (!normalizedRating) return null;
  
  return (
    <div className={styles.reviewContainer}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.ratingContainer}>
        <div className={styles.stars}>
          {stars.map((star, index) => (
            <span
              key={index}
              className={`${styles.star} ${styles[star]}`}
            />
          ))}
        </div>
        <div>
          <span className={styles.rating}>{normalizedRating.toFixed(1)}</span>
          <span className={styles.from}> {`${t("space.ratingsFrom")} 10`}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewStars;